import React, { useEffect } from "react";
import { useAuthStore } from "./store/authStore.js";
import { useCountryStore } from "./store/countryStore.js";
import { Spin } from "antd";

import AllRoutes from "./config/routes/allroutes";

import "./App.css";

function App() {
  const getCountries = useCountryStore((state) => state.getCountries);
  const isLoading = useAuthStore((state) => state.isLoading);
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    getCountries();
  }, [getCountries, user]);

  return (
    <div>
      <AllRoutes />
      <Spin spinning={isLoading} fullscreen />
    </div>
  );
}

export default App;
